import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { captureAttribution } from "./attribution";

/**
 * Captures UTM/creator-code attribution on every location change (LH-114).
 * Mount once inside the router — alongside usePageTracking in App.
 */
export function useAttributionCapture(): void {
  const { search, pathname } = useLocation();

  useEffect(() => {
    captureAttribution();
  }, [search, pathname]);
}
